<template>
  <div class="container">
    <!--作品数据表-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">作品数据</div>
        <div class="title-desc">所选时间内作品产生的收益及互动数据</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">收益来源</span>
          <span class="btnGroup">
            <el-radio
              v-model="incomeType"
              label="1"
              border
              size="medium"
              v-if="permission"
              >收益</el-radio
            >
            <el-radio v-model="incomeType" label="2" border size="medium">
              互动</el-radio
            >
            <el-radio
              v-model="incomeType"
              label="3"
              border
              size="medium"
              v-if="permission"
              >转化</el-radio
            >
          </span>
        </div>
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="productDate"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button
            @click="handlePDateBtnClicked"
            class="search_btn"
            type="info"
            >查找</el-button
          >
          <!--palin-->
        </div>
        <div class="data-table" v-loading="productDataLoading">
          <el-table :data="productData" stripe v-if="incomeType == 1">
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in ProductColData"
              :key="index"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-link @click="lineMapDetail(scope.row.id)">查看详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="productViewData" stripe v-else-if="incomeType == 2">
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in ProductVColData"
              :key="index"
            >
            </el-table-column>
          </el-table>
          <!--转化数据-->
          <el-table :data="ConversionData" stripe v-else>
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in ConversionColData"
              :key="index"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page" v-if="incomeType == 1">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="productDataPageCount"
            @current-change="pDPaginationChange"
          >
          </el-pagination>
        </div>
        <div class="data-filter-page" v-else-if="incomeType == 2">
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            :total="productViewDataPageCount"
            @current-change="pVPaginationChange"
          >
          </el-pagination>
        </div>
        <div class="data-filter-page" v-else>
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            :total="exposureDataTotal"
            @current-change="exposurePageChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudioProductIncome,
  getStudioProductView,
  getExposureDataList,
  getPermiss,
} from '@/api/studio';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      productDataLoading: false,
      productPagination: {
        page_size: 10,
        page: 1,
      },
      productViewPagination: {
        page_size: 10,
        page: 1,
      },
      exposurePagination: {
        page_size: 10,
        page: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      permission: false,
      productDate: '',
      lastProductDate: [],
      incomeType: '1',
      productData: [],
      position: 0,
      productViewData: [],
      ConversionData: [],
      productDataPageCount: 0,
      productViewDataPageCount: 0,
      exposureDataTotal: 0,
      ProductVColData: [
        {
          align: 'center',
          prop: 'product_name',
          label: '作品名称',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'ctype',
          label: '作品类型',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'name',
          label: '作者',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'map_create_time',
          label: '上传时间',
          classname: 'tb-map_create_time',
        },
        {
          align: 'center',
          prop: 'today_download',
          label: '今日下载(预估)',
          classname: 'tb-today_download',
        },
        {
          align: 'center',
          prop: 'yesterday_download_count',
          label: '昨日下载',
          classname: 'tb-yesterday_download_count',
        },
        {
          align: 'center',
          prop: 'download',
          label: '总下载数',
          classname: 'tb-download',
        },
        {
          align: 'center',
          prop: 'play_count',
          label: '游戏次数',
          classname: 'tb-play_count',
        },
        {
          align: 'center',
          prop: 'play_time',
          label: '游戏时长',
          classname: 'tb-play_time',
        },
      ],
      ProductColData: [
        {
          align: 'center',
          prop: 'product_name',
          label: '作品名称',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'ctype',
          label: '作品类型',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'member_name',
          label: '作者',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'minibean',
          label: '累计迷你豆',
          classname: 'tb-accumulateBean',
        },
        {
          align: 'center',
          prop: 'minipoint',
          label: '累计迷你点',
          classname: 'tb-accumulateMiniDot',
        },
        {
          align: 'center',
          prop: 'ad_income',
          label: '累计广告收益',
          classname: 'tb-accumulateAd',
        },
        {
          align: 'center',
          prop: 'ad_count',
          label: '累计广告次数',
          classname: 'tb-countsAd',
        },
        {
          align: 'center',
          prop: 'contribution',
          label: '累计贡献点',
          classname: 'tb-accumulateDot',
        },
      ],
      ConversionColData: [
        {
          align: 'center',
          prop: 'product_name',
          label: '作品名称',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'ctype',
          label: '作品类型',
          classname: 'tb-name',
        },
        {
          align: 'center',
          prop: 'member_name',
          label: '作者',
          classname: 'tb-name',
        },
        // {
        //   align: 'center',
        //   prop: 'date',
        //   label: '上传日期',
        //   classname: 'tb-date'
        // },
        // {
        //   align: 'center',
        //   prop: 'hallExposure',
        //   label: '联机大厅曝光数',
        //   classname: 'tb-hallExposure'
        // },
        // {
        //   align: 'center',
        //   prop: 'play',
        //   label: '游玩人数',
        //   classname: 'tb-play'
        // },
        // {
        //   align: 'center',
        //   prop: 'play_count',
        //   label: '游玩次数',
        //   classname: 'tb-play_count'
        // },
        {
          align: 'center',
          prop: 'exposure',
          label: '广告按钮曝光数',
          classname: 'tb-exposure',
        },
        {
          align: 'center',
          prop: 'hit',
          label: '广告按钮点击数',
          classname: 'tb-hit',
        },
        {
          align: 'center',
          prop: 'rate',
          label: '广告转化率',
          classname: 'tb-rate',
        },
      ],
    };
  },
  created() {
    // const currTime = Date.now()
    //判断是否拥有收入查看权限
    // if (!this.permission) {
    //   this.incomeType = '2';
    // }
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.productDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  watch: {
    incomeType(val) {
      if (val == '1') {
        (this.productPagination.page = 1), this.getProductData();
      } else if (val == '2') {
        (this.productViewPagination.page = 1), this.getProductViewData();
      } else {
        (this.exposurePagination.page = 1), this.getExposureData();
      }
    },
  },
  mounted() {
    //作品数据
    this.getProductData();
    //作品数据-互动数据
    this.getProductViewData();
    //转化数据
    this.getExposureData();
    this.getPerssion();
  },
  filters: {
    MemberTypeFilter(type) {
      return type ? '签约成员' : '普通成员';
    },
  },
  methods: {
    handlePDateBtnClicked() {
      //this.getProductViewData()
      if (this.incomeType == 2) {
        //if(this.lastProductDate[0]=== this.productDate[0]&&this.lastProductDate[1]===this.productDate[1])return
        this.getProductViewData();
      } else if (this.incomeType == 1) {
        //if(this.lastProductDate[0]===this.productDate[1]&&this.lastProductDate[1]===this.productDate[1])return
        this.getProductData();
      } else {
        this.getExposureData();
      }
    },
    exportFn() {
      this.fetchExport();
    },
    //判断是否有收入查看权限
    async getPerssion() {
      let res = await getPermiss({ json: 1 });
      this.position = res.data.position;
      if (res.data.v1m_income == 1 || this.position == 1) {
        this.permission = true;
      } else {
        this.permission = false;
      }
      if (!this.permission) {
        this.incomeType = '2';
      }
    },
    //导出数据
    async fetchExport() {},
    toastMessage() {
      this.$message.error('仅能查看签约成员数据哦');
    },
    //作品-互动表分页
    pDPaginationChange(currPage) {
      this.productPagination.page = currPage;
      this.getProductData();
    },
    //作品-互动表分页
    pVPaginationChange(currPage) {
      this.productViewPagination.page = currPage;
      // console.log(this.productViewPagination.page)
      this.getProductViewData();
    },
    //做品-转化表分页
    exposurePageChange(currPage) {
      this.exposurePagination.page = currPage;
      this.getExposureData();
    },
    //作品数据总览-收益数据
    async getProductData() {
      this.productDataLoading = true;
      this.lastProductDate = this.productDate;
      const res = await getStudioProductIncome(
        Object.assign(
          { income_type: this.incomeType },
          this.productPagination,
          {
            start_time: parseInt(this.productDate[0] / 1000, 10),
            end_time: parseInt((this.productDate[1] + ONE_DAY_TIME) / 1000, 10),
          },
        ),
      );
      this.productDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.productData = list.map(item => {
            item.contribution = Number(item.contribution).toFixed(3);
            item.ctype =
              item.ctype === 1
                ? '地图'
                : item.ctype === 2
                ? '游戏'
                : item.ctype;
            return item;
          });
        }
        this.productDataPageCount = parseInt(res.data.total_count, 10);
      }
    },
    //作品数据总览-互动数据
    async getProductViewData() {
      this.productDataLoading = true;
      this.lastProductDate = this.productDate;
      const res = await getStudioProductView(
        Object.assign(this.productViewPagination, {
          start_time: parseInt(this.productDate[0] / 1000, 10),
          end_time: parseInt((this.productDate[1] + ONE_DAY_TIME) / 1000, 10),
          json: 1,
        }),
      );
      this.productDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.productViewData = list.map(item => {
            item.play_time = Number(item.play_time).toFixed(2);
            item.ctype =
              item.ctype === 1
                ? '地图'
                : item.ctype === 2
                ? '游戏'
                : item.ctype;
            return item;
          });
        }
        this.productViewDataPageCount = parseInt(res.data.total_count, 10);
      }
    },
    //作品数据-转化数据
    async getExposureData() {
      this.productDataLoading = true;
      this.lastProductDate = this.productDate;
      const res = await getExposureDataList({
        page_size: this.exposurePagination.page_size,
        page: this.exposurePagination.page,
        start_time: parseInt(this.productDate[0] / 1000, 10),
        end_time: parseInt((this.productDate[1] + ONE_DAY_TIME) / 1000, 10),
        income_type: 1,
      });
      //this.expo
      this.productDataLoading = false;
      this.ConversionData = (res.data.list || []).map(item => {
        item.ctype =
          item.ctype === 1 ? '地图' : item.ctype === 2 ? '游戏' : item.ctype;
        return item;
      });
      this.exposureDataTotal = parseInt(res.data.total_count, 10);
    },
    lineMapDetail(tid) {
      this.$router.push({ path: '/charts/detail', query: { id: tid } });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .data-table {
    margin-top: 28px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    text-align: center;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
  }
  ::v-deep .el-button--text {
    color: #2b6ddf;
  }
  ::v-deep .el-date-editor.el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-range-editor.el-input__inner {
    padding: 3px 0;
  }
  ::v-deep .el-date-editor .el-range__icon {
    display: none;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 30px;
    color: #bfbfbf;
  }
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
    border-right: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background-color: #f4f4f5;
  }
  .download-wrap {
    float: right;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    margin-top: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b6ddf;
    img {
      margin-right: 8px;
    }
  }
  .all-look {
    color: #2b6ddf;
    text-decoration: underline;
    display: flex;
    justify-content: center;
  }
}
</style>
